import { mapGetters } from "vuex"

export default {
  methods: {
    sortBy(arr, key) {
      arr.sort((a, b) => Intl.Collator().compare(a[key], b[key]))
    }
  },
  computed: {
    ...mapGetters(["catalogues"]),
    catalogue() {
      if (this.champ) {
        let found = this.catalogues.find((c) => c.descId == this.champ.catalogueReference)
        if (found) {
          return found
        }
      }
      return null
    },
    allValeurs() {
      if (this.catalogue) {
        return this.catalogue.valeurs
      }
      return []
    },
    valeurs() {
      if (this.catalogue) {
        let filter = this.catalogue.valeurs.filter((fd) => {
          if (this.parent && fd.parent != this.parent) {
            return false
          }
          if (this.filter && !this.filter(fd)) {
            return false
          }

          if (this.codeExclude) {
            let foundCode = this.codeExclude.find((c) => c.code == fd.code)
            if (foundCode && foundCode.condition) {
              return false
            }
          }

          if (this.codeFilter) {
            let foundCode = this.codeFilter.find((c) => c.code == fd.code)
            if (!(foundCode && foundCode.condition)) {
              return false
            }
          }

          return true
        })
        this.sortBy(filter, this.orderBy)
        return filter
      }

      return []
    }
  }
}